import DiscussMariaAbout from "components/About/DiscussMariaAbout";
import HeroAbout from "components/About/HeroAbout";
import MainAbout from "components/About/MainAbout";
import Mission from "components/About/Mission";
import OurApproach from "components/About/OurApproach";
import Quote from "components/About/Quote";
import SocialMedia from "components/About/SocialMedia";
import Team from "components/About/Team";
import Whowehelp from "components/About/Whowehelp";
import WhyChooseUs from "components/About/WhyChooseUs";
import MainClient from "components/Client&Partner/MainClient";
import Testimonial from "components/Client&Partner/Testimonial";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const About = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div className="bg-darkbg">
      {/* <HeroAbout /> */}
      <Mission />
      <Quote />
      <div id="maria">
        <MainAbout />
      </div>
      <div id="approach">
        <OurApproach />
      </div>
      <div id="team">
        <Team />
      </div>
      <div id="clients">
        <Whowehelp />
      </div>
      <div id="why-us">
        <WhyChooseUs />
      </div>
      <div id="success">
        <Testimonial />
      </div>{" "}
      <DiscussMariaAbout />
    </div>
  );
};

export default About;
